/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Business line services
  Date: April 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();
import { globalPageLimit } from '../constants/applicationConstants';

export const getBusinessLineList = (payload) => {
  const queryString = (payload) ? `${payload}&limit=${globalPageLimit.LOB_LIMIT}&purpose=listing` : `limit=${globalPageLimit.LOB_LIMIT}&purpose=listing`;
  return API.get(`lob/businesslines?${queryString}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};
